const INITIAL_STATE = {
    repassesAoVendedor: [],
    repasseAoVendedor: {}
}

export default function Pagamentos(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'REPASSES_FETCHED' :
            return { ...state, repassesAoVendedor: action.payload }
        case 'REPASSE_FETCHED' :
            return { ...state, repasseAoVendedor: action.payload }
        default :
            return state
    }
}